export const fieldRenderForSmallField = {
  gridTemplateColumns: "160px 1fr 1fr",
  width: "100%",
}
